import { useState } from "react";

import useMedia from "../../hooks/useMedia";

import UploadDropzone from "./components/UploadDropzone";
import SelectedFileCard from "./components/SelectedFileCard";
import FolderSelector from "./components/FolderSelector";
import UploadActions from "./components/UploadActions";
import { toastError, toastSuccess } from "../../../../common/utils/toast";

const DEFAULT_FOLDERS = [

    {
        value:"documents",
        label:"Documents"
    },

    {
        value:"products",
        label:"Products"
    },

    {
        value:"content",
        label:"Content"
    },

    {
        value:"assignments",
        label:"Assignments"
    },

    {
        value:"certificates",
        label:"Certificates"
    },

    {
        value:"users",
        label:"Users"
    }

];

export default function MediaUploadForm({

    onSuccess,

    onCancel,

    folders = DEFAULT_FOLDERS

}){

   
    const {

        uploadMedia

    } = useMedia();

    const [

        file,

        setFile

    ] = useState(null);

    const [

        folder,

        setFolder

    ] = useState(

        folders[0]?.value ||

        "documents"

    );

    const [

        loading,

        setLoading

    ] = useState(false);

    const [

        dragging,

        setDragging

    ] = useState(false);

    function selectFile(files){

        if(!files?.length){

            return;

        }

        setFile(files[0]);

    }

    function handleDragOver(e){

        e.preventDefault();

        setDragging(true);

    }

    function handleDragLeave(e){

        e.preventDefault();

        setDragging(false);

    }

    function handleDrop(e){

        e.preventDefault();

        setDragging(false);

        selectFile(

            e.dataTransfer.files

        );

    }

    async function handleSubmit(e){

        e.preventDefault();

        if(!file){

            toastError(

                "Please select a file."

            );

            return;

        }

        try{

            setLoading(true);

            const formData =

                new FormData();

            formData.append(

                "file",

                file

            );

            formData.append(

                "folder",

                folder

            );

            await uploadMedia(

                formData

            );

            toastSuccess(

                "File uploaded successfully."

            );

            setFile(null);

            onSuccess?.();

        }

        catch(error){

            toastError(

                error?.response?.data?.message ||

                error?.message ||

                "Upload failed."

            );

        }

        finally{

            setLoading(false);

        }

    }

    return(

        <form onSubmit={handleSubmit}>

            <UploadDropzone

                dragging={dragging}

                onDragOver={handleDragOver}

                onDragLeave={handleDragLeave}

                onDrop={handleDrop}

                onSelect={selectFile}

            />

            <SelectedFileCard

                file={file}

                onRemove={()=>

                    setFile(null)

                }

            />

            <FolderSelector

                value={folder}

                folders={folders}

                onChange={setFolder}

            />

            <UploadActions

                loading={loading}

                onCancel={onCancel}

            />

        </form>

    );

}